import { gql } from '@apollo/client';

import { useMutationCompat as useMutation } from '../../lib/apollo/mutationCompat';

const CREATE_AZURE_TICKET = gql`
  mutation($workItem: WorkItemInput!) 
  {
    CreateAzureWorkItem(workItem: $workItem)
  }
`;

export function useTicketMutations() {

  const [createAzureTicket] = useMutation(CREATE_AZURE_TICKET,
    {  },
  );

  return { createAzureTicket };
}
